// src/pages/driverMgmtPage.js
import React, { useEffect, useState } from "react";
import { api } from "../scripts/api";
import Modal from "../components/Modal";

export default function DriversPage() {
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [birthday, setBirthday] = useState("");
  const [passportNum, setPassportNum] = useState("");
  const [passportExp, setPassportExp] = useState("");
  const [dealerPlate, setDealerPlate] = useState("");
  const [dealerExp, setDealerExp] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    loadDrivers();
  }, []);

  const loadDrivers = async () => {
    setBusy(true);
    setMsg("");
    try {
      const { data } = await api.get("/driver");
      setDrivers(Array.isArray(data) ? data : []);
    } catch (e) {
      setMsg(e?.response?.data?.error || "Failed to load drivers.");
      setDrivers([]);
    } finally {
      setBusy(false);
    }
  };

  const createOrUpdateDriver = async () => {
    if (!fullName.trim()) {
      setMsg("Full name required.");
      return;
    }

    const payload = {
      FullName: fullName,
      Email: email,
      Phone: phone,
      Birthday: birthday,
      PassportNum: passportNum,
      PassportExp: passportExp,
      DealerPlate: dealerPlate,
      DealerExp: dealerExp,
    };

    setBusy(true);
    setMsg("");
    try {
      if (editMode) {
        await api.put(`/driver/${selectedDriver.DriverId}`, payload);
        setMsg("Driver updated.");
      } else {
        await api.post("/driver", payload);
        setMsg("Driver created.");
      }
      resetForm();
      loadDrivers();
      closeModal();
    } catch (e) {
      setMsg(e?.response?.data?.error || "Operation failed.");
    } finally {
      setBusy(false);
    }
  };

  const deleteDriver = async (DriverId) => {
    if (!window.confirm("Delete this driver?")) return;
    setBusy(true);
    try {
      await api.delete(`/driver/${DriverId}`);
      setMsg("Driver deleted.");
      loadDrivers();
    } catch (e) {
      setMsg(e?.response?.data?.error || "Delete failed.");
    } finally {
      setBusy(false);
    }
  };

  const openCreateModal = () => {
    resetForm();
    setEditMode(false);
    setSelectedDriver({});
  };

  const openEditModal = (driver) => {
    setFullName(driver.FullName || "");
    setEmail(driver.Email || "");
    setPhone(driver.Phone || "");
    setBirthday(driver.Birthday || "");
    setPassportNum(driver.PassportNum || "");
    setPassportExp(driver.PassportExp || "");
    setDealerPlate(driver.DealerPlate || "");
    setDealerExp(driver.DealerExp || "");
    setEditMode(true);
    setSelectedDriver(driver);
  };

  const closeModal = () => {
    setSelectedDriver(null);
    setEditMode(false);
  };

  const resetForm = () => {
    setFullName("");
    setEmail("");
    setPhone("");
    setBirthday("");
    setPassportNum("");
    setPassportExp("");
    setDealerPlate("");
    setDealerExp("");
  };

  return (
    <div className="container">
      <div className="row" style={{ justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <h2 style={{ margin: 0, fontWeight: 900 }}>Drivers Management</h2>
        <button className="btn-outline" onClick={loadDrivers} disabled={busy}>
          Refresh
        </button>
        <button className="btn" onClick={openCreateModal} disabled={busy}>
          Add Driver
        </button>
      </div>

      {msg ? (
        <div className="muted" style={{ marginTop: 10, whiteSpace: "pre-wrap" }}>
          {msg}
        </div>
      ) : null}

      <div className="card" style={{ marginTop: 12 }}>
        <div style={{ fontWeight: 900, marginBottom: 10 }}>Existing Drivers</div>
        {busy ? <div className="muted">Loading…</div> : null}

        <div style={{ display: "grid", gap: 10 }}>
          {drivers.map((d) => (
            <div key={d.DriverId} className="card" style={{ background: "rgba(255,255,255,0.02)" }}>
              <div className="row" style={{ justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                <div>
                  <div style={{ fontWeight: 900 }}>{d.FullName}</div>
                  <div className="muted" style={{ marginTop: 4 }}>
                    Email: {d.Email || '(none)'} • Phone: {d.Phone || '(none)'}
                  </div>
                </div>

                <div className="row" style={{ gap: 8, flexWrap: "wrap" }}>
                  <button className="btn-outline" onClick={() => openEditModal(d)}>
                    Edit
                  </button>
                  <button className="btn-outline" onClick={() => deleteDriver(d.DriverId)}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}

          {!busy && drivers.length === 0 ? <div className="muted">No drivers found.</div> : null}
        </div>
      </div>

      {selectedDriver && (
        <Modal onClose={closeModal}>
          <h2>{editMode ? "Edit Driver" : "Add Driver"}</h2>

          <div className="row" style={{ gap: 10, flexWrap: "wrap" }}>
            <input
              className="input"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
            <input
              className="input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="input"
              placeholder="Phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <input
              className="input"
              placeholder="Birthday"
              value={birthday}
              onChange={(e) => setBirthday(e.target.value)}
            />
            <input
              className="input"
              placeholder="Passport Number"
              value={passportNum}
              onChange={(e) => setPassportNum(e.target.value)}
            />
            <input
              className="input"
              placeholder="Passport Exp"
              value={passportExp}
              onChange={(e) => setPassportExp(e.target.value)}
            />
            <input
              className="input"
              placeholder="Dealer Plate"
              value={dealerPlate}
              onChange={(e) => setDealerPlate(e.target.value)}
            />
            <input
              className="input"
              placeholder="Dealer Exp"
              value={dealerExp}
              onChange={(e) => setDealerExp(e.target.value)}
            />
            <button className="btn" onClick={createOrUpdateDriver} disabled={busy}>
              {editMode ? "Update" : "Create"}
            </button>
          </div>

          <button className="btn-outline" onClick={closeModal}>Close</button>
        </Modal>
      )}
    </div>
  );
}